// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"625":"de13d196","820":"488bcb68"}[chunkId] + ".chunk.js";
};